import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import RequirePcoAuth from './requirePcoAuth';
import usePcoAuthUser from './usePcoAuthUser';
import Card from '../../components/dashboard/card';
import { congregantDonationsReimbursementsPath, congregantPortalLoginPath } from '../../constants';

const PORTAL_CARDS = [
  {
    to: congregantDonationsReimbursementsPath,
    icon: faReceipt,
    title: 'Donations & Reimbursements',
    description: 'Log a donation, or generate a reimbursement or check request PDF',
  },
];

// Congregant-facing dashboard, gated on Planning Center login instead of
// the admin portal's Firebase login. Only the donations/reimbursements
// form is wired up here for now.
const PortalDashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, logout } = usePcoAuthUser();

  const mainStyle = {
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.brand.linen,
    paddingTop: 'var(--nav-height)',
    minHeight: '100vh',
    boxSizing: 'border-box',
  };

  const eyebrowStyle = {
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: theme.palette.brand.brass,
    margin: '0 0 6px',
  };

  const headingStyle = {
    fontFamily: theme.typography.secondaryFontFamily,
    fontWeight: 600,
    color: theme.palette.primary.dark,
    fontSize: 'min(8vw, 34px)',
    margin: 0,
  };

  const handleSignOut = () => {
    logout();
    window.location.href = congregantPortalLoginPath;
  };

  return (
    <div style={mainStyle}>
      <RequirePcoAuth />

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px 20px 32px' }}>
        <div
          style={{
            marginBottom: '24px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: '16px',
          }}
        >
          <div>
            <div style={eyebrowStyle}>Congregant Portal</div>
            <h1 style={headingStyle}>Dashboard</h1>
          </div>

          {user && (
            <div style={{ textAlign: 'right' }}>
              <div
                style={{
                  fontFamily: theme.typography.paragraphFontFamily,
                  fontSize: '13px',
                  color: theme.palette.text.secondary,
                  marginBottom: '4px',
                }}
              >
                Signed in as {user.name} via Planning Center
              </div>
              <button
                type="button"
                onClick={handleSignOut}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  fontFamily: theme.typography.fontFamily,
                  fontSize: '13px',
                  fontWeight: 600,
                  color: theme.palette.text.secondary,
                  cursor: 'pointer',
                }}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>

        <div style={eyebrowStyle}>Manage</div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
            gap: '10px',
            marginTop: '12px',
          }}
        >
          {PORTAL_CARDS.map((card) => (
            <div key={card.to} onClick={() => navigate(card.to)} style={{ cursor: 'pointer' }}>
              <Card icon={card.icon} title={card.title} description={card.description} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortalDashboard;
